import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/modules/shared.module';
import { BalanceService } from './services/balance.service';
import { WindowRef } from '../../shared/services/window.service';
import { MaintenanceResourceService } from '../../shared/services/maintenance-resource.service';
import { BalanceRoutingModule } from './balance-routing.module';
import { BalanceComponent } from './components/balance.component';
import { PrincipalService } from '../../shared';
import { MyDatePickerModule } from 'mydatepicker';
import { AccountResourceApi } from '../../shared/services/api/account-resource.api';
import { ProfileApi } from '../../shared/services/api/profile.api';
import { MaintenanceApi } from '../../shared/services/api/maintenance.api';
import { DocumentResourceService } from '../../shared/services/document-resource.service';
import { DocumentResourceApi } from '../../shared/services/api/document-resource.api';
import { CommaSeparatorPipe } from '../../shared/pipes/currency-formatter/comma-separator.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BalanceRoutingModule,
    SharedModule,
    MyDatePickerModule,
    PopoverModule.forRoot(),
    TooltipModule.forRoot(),
    TranslateModule.forChild(),
  ],
  declarations: [BalanceComponent, CommaSeparatorPipe],
  exports:[FormsModule,ReactiveFormsModule],
  providers: [
    BalanceService,
    WindowRef,
    MaintenanceResourceService,
    PrincipalService,
    DocumentResourceService,
    AccountResourceApi,
    ProfileApi,
    MaintenanceApi,
    DocumentResourceApi
  ]
})
export class BalanceModule { }
